import classNames from 'classnames';
import React__default from 'react';
import { getPrefixCls } from '../../../utils/getPrefix.js';

var prefixCls = getPrefixCls('dotIndicator');
var DotIndicator = function DotIndicator(_ref) {
  var className = _ref.className,
    _ref$dataTestid = _ref.dataTestid,
    dataTestid = _ref$dataTestid === void 0 ? 'dotindicator' : _ref$dataTestid;
  return /*#__PURE__*/React__default.createElement("div", {
    "sl-test-data": dataTestid,
    className: classNames(prefixCls, className, {})
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_dots")
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "".concat(prefixCls, "_dot ").concat(prefixCls, "_dot-1")
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "".concat(prefixCls, "_dot ").concat(prefixCls, "_dot-2")
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "".concat(prefixCls, "_dot ").concat(prefixCls, "_dot-3")
  })));
};

export { DotIndicator };
